/* PDP thumbnail row below main image (desktop) */
(function initProductThumbnailBelowLayoutModule() {
  function applyProductThumbnailBelowLayout(swiper, product) {
    if (!swiper || !product || product.dataset.thumbnailPosition !== 'below') return;

    const isDesktop = window.matchMedia('(min-width: 768px)').matches;

    swiper.changeDirection('horizontal');
    swiper.params.slidesPerView = isDesktop ? 'auto' : 4;
    swiper.params.spaceBetween = isDesktop ? 20 : 8;
    swiper.params.freeMode = true;

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    swiper.slideTo(swiper.activeIndex, 0);

    const featureSwiper = product.querySelector('.carousel--featured-product')?.swiper;
    if (featureSwiper?.thumbs) {
      featureSwiper.thumbs.update();
    }

    if (typeof attachSwiperAccessibility === 'function' && !swiper._a11yAttached) {
      attachSwiperAccessibility(swiper);
    } else if (typeof updateCarouselAccessibility === 'function') {
      updateCarouselAccessibility(swiper);
    }
  }

  function setupProductThumbnailBelowLayout(product) {
    if (product.dataset.thumbnailPosition !== 'below') return;

    const apply = () => {
      const thumbsEl = product.querySelector('.carousel--product-thumbnails');
      if (!thumbsEl?.swiper) return false;
      applyProductThumbnailBelowLayout(thumbsEl.swiper, product);
      return true;
    };

    if (apply()) return;

    let attempts = 0;
    const poll = setInterval(() => {
      attempts += 1;
      if (apply() || attempts >= 100) {
        clearInterval(poll);
      }
    }, 100);
  }

  function initProductThumbnailBelowLayout() {
    document.querySelectorAll('.product[data-thumbnail-position="below"]').forEach(setupProductThumbnailBelowLayout);
  }

  function onReady() {
    initProductThumbnailBelowLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
